import { FileListItem } from './FileListItem';
import { PicturePack } from './PicturePack';


export class OnlineDemoPicturesStorage
{
    constructor(public url: string = "https://photos.specteam.pl") 
    { }

    public async GetDir(dir: string = ""): Promise<FileListItem[]>
    {
        const response = await fetch(this.url + "/list/" + dir);
        const list = await response.json() as FileListItem[];
        return list;
    }

    public async GetFiles(dir: string = "tx-demo"): Promise<PicturePack[]>
    {
        const items = await this.GetDir(dir);

        const files = items.filter(x => x.Type === "file");

        const filesNames = files.map(x => x.Name);

        return this.NamesToPicturePacks(filesNames, dir);
    }

    private ToFullUrl(dir: string, file: string): string
    {
        return this.url + "/pic/" + dir + "/" + file;
    }

    private NamesToPicturePacks(fileNames: string[], dir: string): PicturePack[]
    {
        const map = new Map();

        fileNames.forEach(file =>
        {
            const match = file.match(/^(.+?)\.(original|normalized|thumbnail|mini)\.(\w+)$/);
            if (match)
            {
                const [_, baseName, type, extension] = match;

                if (!map.has(baseName))
                {
                    map.set(baseName, new PicturePack(baseName, extension));
                }

                const pack = map.get(baseName);

                switch (type)
                {
                    case "original":
                        pack.Original = this.ToFullUrl(dir, file);
                        break;
                    case "normalized":
                        pack.Normalized = this.ToFullUrl(dir, file);
                        break;
                    case "thumbnail":
                        pack.Thumbnail = this.ToFullUrl(dir, file);
                        break;
                    case "mini":
                        pack.Mini = this.ToFullUrl(dir, file);
                        break;
                }
            }
        });

        return Array.from(map.values());
    }
}
